import { SHOW_GLOBAL_LOADING, HIDE_GLOBAL_LOADING } from './types'
import * as Service from '../utils/services/index.js'
import { getShortLink, walletLink } from '../utils/services/index.js'

export default {
    showGlobalLoading({ commit }) {
        commit(SHOW_GLOBAL_LOADING)
    },
    hideGlobalLoading({ commit }) {
        commit(HIDE_GLOBAL_LOADING)
    },
    /**
     * @desc 发送邮箱验证码
     * @param {Object} state
     * @param {String} email - 邮箱地址
     * @return {Promise}
     */
    sendEmailVerifyCode({ commit }, email) {
        return new Promise((resolve, reject) => {
            Service.sendEmailVerifyCode(email).then(
                (result) => {
                    resolve(result)
                },
                (err) => {
                    reject(err)
                }
            )
        })
    },
    /**
     * @desc 发送邮箱验证码
     * @param {Object} state
     * @param {String} email - 邮箱地址
     * @return {Promise}
     */
    sendEmailVerifyCodeNew({ commit }, email) {
        return new Promise((resolve, reject) => {
            Service.sendEmailVerifyCodeNew(email).then(
                (result) => {
                    resolve(result)
                },
                (err) => {
                    reject(err)
                }
            )
        })
    },
    /**
     * @desc 预注册
     * @param {*} store
     * @param {*} body
     */
    preRegist({ commit }, body) {
        return Service.preRegist(body)
    },
    /**
     * @desc 预注册
     * @param {*} store
     * @param {*} body
     */
    sendCode({ commit }, body) {
        return Service.sendCode(body)
    },
    /**
     * @desc 查询用户相关信息
     * @param {*} param0
     */
    fetchUserInfo({ commit }) {
        return Service.fetchUserInfo()
    },
    /**
     * @desc 生成二维码图片
     * @param {*} param0
     * @param {*} url
     */
    generateBarcode({ commit }, url) {
        return Service.generateBarcode({ url: url })
    },
    /**
     * @desc 图形验证码
     * @param {*} param0
     * @param {*} body
     */
    refreshCaptcha({ commit }, body) {
        return Service.refreshCaptcha(body)
    },
    /**
     * @desc 发送手机验证码,注册场景
     * @param {*} param0
     * @param {*} body
     */
    sendMobileVerifyCodeV2({ commit }, body) {
        return Service.sendMobileVerifyCodeV2(body)
    },
    /**
     * @desc 获取微信URL Scheme
     * @param {*} param0
     * @param {*} body
     */
    getShortLink({ commit }, body) {
        return Service.getShortLink(body)
    },
    /**
     * @desc 发送手机验证码,联系方式，绑卡场景
     * @param {*} param0
     * @param {*} body
     */
    sendUserMobileVerifyCodeV2({ commit }, body) {
        return Service.sendUserMobileVerifyCodeV2(body)
    },
    /**
     * @desc 获取app配置信息
     * @param {*} param0
     * @param {*} body
     */
    refreshAppconfig({ commit }, body) {
        return Service.refreshAppconfig(body)
    },
    /**
     * @desc 万达贷预注册页面利率查询
     * @param {*} param0
     * @param {*} body
     */
    homeproductsrate({ commit }, body) {
        return Service.homeproductsrate(body)
    },
    // app最新版本号
    getLatestVersion({ commit }, body) {
        return Service.getLatestVersion(body)
    },
    // PE调查提交
    questionnaireSave({ commit }, body) {
        return Service.questionnaireSave(body)
    },
    /**
     * @desc 光大银行获取手机号
     * @param {*} store
     * @param {*} body
     */
    queryMobile({ commit }, body) {
        return Service.queryMobile(body)
    },
    /**
     * @desc 万达钱包会员权益红包
     * @param {*} store
     * @param {*} body
     */
    memberRedPacket({ commit }, body) {
        return Service.memberRedPacket(body)
    },
    /**
     * @desc 微信小程序短链
     * @param {*} param0
     */
    walletLink({ commit }, body) {
        return Service.walletLink(body)
    },
    /**
     * @desc 万达贷微信小程序短链
     * @param {*} param0
     */
    wddLink({ commit }, body) {
        return Service.wddLink(body)
    },
    /**
     * @desc 商户代运营-用户登录
     * @param {*}
     */
     threeUserLogin({ commit }, body) {
        return Service.threeUserLogin(body)
    },
    /**
     * @desc 三贷用户信息查询
     * @param {*}
     */
     threeUserInfo({ commit }, body) {
        return Service.threeUserInfo(body)
    },
    /**
     * @desc 会员权益入口
     * @param {*}
     */
    menuUrl({ commit }, body) {
        return Service.menuUrl(body)
    },
    /**
     * @desc 列表
     * @param {*}
     */
    menuList({ commit }, body) {
        return Service.menuList(body)
    },
    /**
     * @desc 备用金注册通知万达钱包
     * @param {*}
     */
    walletSendCoupon({ commit }, body) {
        return Service.walletSendCoupon(body)
    },
    /**
     * @desc 初审额度获取接口
     * @param {*}
     */
    getSimpleCreditApply({ commit }, body) {
        return Service.getSimpleCreditApply(body)
    },
    /**
     * @desc 微信 JSSDK 签名
     * @param {*} param0
     * @param {String} pageUrl
     */
    wxSignature({ commit }, body) {
        return Service.wxSignature(body)
    },
}



// WEBPACK FOOTER //
// ./src/store/actions.js